import React, { useState, useEffect } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import SignUpApp from "./SignUpApp";
import Progress from "./Progress";
import Hero from "./Hero";
import Nav from "./Nav";
import "./styles.css";
import Profile from "./Profile";
import EditProfile from "./EditProfile";
import About from "./About";
import NotFound from "./NotFound";
// import Testing from "./Testing";
export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Nav />
        <Routes>
          {/* <Route path="/testing" element={<Testing /> } /> */}
          <Route path="/" element={<Hero />} />
          <Route path="/register" element={<SignUpApp />} />
          <Route path="/progress" element={<Progress />} />

          {/* <Route path="/edit" element={<EditProfile />} /> */}
          <Route path="/profile" element={<Profile />} />
          <Route path="/about" element={<About />} />

          <Route path="profile/edit/:emailForEdit" element={<EditProfile />} />

          <Route path="*" element={<NotFound />} />
        </Routes>
        <div className="underline" style={{ marginTop: 140 }}></div>
        <p className="information" style={{ marginTop: 10 }}>
          Made with 💟 by{" "}
          <a
            style={{ color: "white", textDecoration: "underline" }}
            href="https://bit.ly/KINFISHTECH"
          >
            <b>KINFE</b>
          </a>
        </p>
      </BrowserRouter>
    </div>
  );
}
